import api from './../../api/api'

export default {
  
  users: async (page, take, sortBy, sortOrder, search) => {
    return api.get(`api/users?page=${page}&take=${take}&sort_by=${sortBy}&sort_order=${sortOrder}&search=${search}`)
  },

  create: async user => {
    return api.post('api/users', user)
  },

  get: async id => {
    return api.get('api/users/' + id)
  },

  update: async (id, user) => {
    return api.put('api/users/' + id, user)
  },

  delete: async id => {
    return api.delete('api/users/' + id)
  }
}
